<template>
  <a-layout-content v-if="data.length !== 0">
    <div v-if="pageLoading === false">
      <a-row :gutter="8">
        <a-col :xs="{span:24}">
          <a-card :loading="pageLoading" class="m-bottom">
            <div slot="title">Manifest Cuti</div>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>No Cuti</span>
                <span class="list-desc">{{data.header.no_cuti}}</span>
              </li>
              <li>
                <span class="list-title" for>Tanggal Buat</span>
                <span class="list-desc">{{data.header.tgl_buat}}</span>
              </li>
              <li>
                <span class="list-title" for>User Pembuat</span>
                <span class="list-desc">{{data.header.pembuat}}</span>
              </li>
              <li>
                <span class="list-title" for>Unit Kerja</span>
                <span class="list-desc">{{data.header.unit_kerja}}</span>
              </li>
              <li>
                <span class="list-title" for>Jabatan</span>
                <span class="list-desc">{{data.header.jabatan}}</span>
              </li>
              <li>
                <span class="list-title" for>Tanggal Cuti</span>
                <span class="list-desc">{{data.header.tgl_cuti}}</span>
              </li>
              <li>
                <span class="list-title" for>Keperluan</span>
                <span class="list-desc">{{data.header.keperluan}}</span>
              </li>
            </ul>
          </a-card>
          <a-collapse class="m-top" activeKey="">
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="m-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{data.user_pembuat.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4 class="m-remove">{{data.user_pembuat.tanggal}}</h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{data.user_pembuat.status}}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'red' : workflow.status === 'Waiting' ? 'grey' : 'green'"
                >
                  <div
                    class="m-timeline-title"
                  >{{workflow.actor === null ? workflow.jenis : workflow.actor}} {{workflow.tlc ? ' - ' + workflow.tlc : ''}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="m-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{workflow.remark}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="m-top"
            :loading="pageLoading"
            v-if="data.jenis.toLowerCase() === 'approve'"
          >
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Password">
                <a-input
                  type="password"
                  placeholder="Password"
                  v-decorator="['password', {rules: [{required: true}]}]"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleSubmit" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleSubmitProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSubmitProcess);
  },
  computed: {
    ...mapGetters(["getScreen"])
  },
  methods: {
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_cuti",
        params: {
          id: this.id
        }
      })
        .then(response => {
          console.log(response);
          this.data = {
            header: {
              no_cuti: response.data.invoice[0].no_cuti,
              tgl_buat: response.data.invoice[0].tgl_buat,
              pembuat: response.data.invoice[0].user_pembuat,
              unit_kerja: response.data.invoice[0].unit_kerja,
              jabatan: response.data.invoice[0].jabatan,
              tgl_cuti: response.data.invoice[0].tanggal_cuti,
              keperluan: response.data.invoice[0].keperluan
            },
            actor: response.data.tlc,
            id: response.data.id_cuti,
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].user_pembuat,
              tanggal: response.data.invoice[0].tgl_buat,
              status: "Created"
            },
            status: response.data.status_app,
            aksi: response.data.aksi
          };
          this.pageLoading = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan system, error code 404!"
            });
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.confirmMessage("confirm-save");
    },
    handleSubmitProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.$notification.error({
            message: "Error",
            description: "Pilih Aksi Terlebih Dahulu!"
          });
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.data.id);
        postData.append("status", values.aksi);
        postData.append("remark", values.catatan ? values.catatan : "");
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_cuti",
          processData: false,
          data: postData
        })
          .then(response => {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil diproses!"
            });
            this.$router.go();
          })
          .catch(err => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.$notification.error({
                message: "Error",
                description: "Password Anda Salah!"
              });
            }
            this.pageLoading = false;
          });
      });
    }
  }
};
</script>

<style>
</style> 